export default function getViewCheckpointId() {
  const isInIframe = window.self !== window.top;
  if (!isInIframe) {
    return undefined;
  }

  const dashboardIframe = window.parent.document.getElementById(
    'view-checkpoint-iframe',
  );

  if (!dashboardIframe) {
    return undefined;
  }

  const iframeUrl = new URL(dashboardIframe.src, window.location.origin);
  const params = new URLSearchParams(iframeUrl.search);
  const viewCheckpointId = params.get('viewCheckpointId');

  return viewCheckpointId;
}
